/**
 * Labstep
 *
 * @module components/ProtocolCondition/Action/ToggleVariable
 * @desc Set isVariable action
 */

import { EntityActionUpdateContainer as EntityActionUpdate } from 'labstep-web/components/Entity/Action/Update';
import { OrganizationPremiumFeatureToggle } from 'labstep-web/components/Organization/PremiumFeatureToggle';
import { useProtocolConditionModalContext } from 'labstep-web/components/ProtocolCondition/Modal/context';
import { useHasFeatureFlagEnabled } from 'labstep-web/hooks/feature-flag';
import type React from 'react';
import type { IProtocolConditionActionToggleIsVariableProps } from './types';

export const ProtocolConditionActionToggleIsVariable: React.FC<
  IProtocolConditionActionToggleIsVariableProps
> = ({ entity, toggle = true, protocol, params }) => {
  const { setIsOpen } = useProtocolConditionModalContext();

  if (!useHasFeatureFlagEnabled('multiplexing')) {
    return (
      <OrganizationPremiumFeatureToggle premiumFeature="multiplexing" />
    );
  }
  return (
    <EntityActionUpdate
      entityName={entity.entityName}
      id={entity.idAttr}
      body={{ is_variable: !entity.is_variable }}
      actionComponentProps={{
        dataTestId: 'action-toggle-is-variable',
        dataCy: 'components/ProtocolCondition/Action/ToggleVariable',
        type: 'checkbox',
        elementProps: {
          toggle,
          checked: entity.is_variable,
        },
      }}
      options={{
        onSuccess: (response): void => {
          if (params?.onSuccess) {
            params.onSuccess(response);
          }
          if (!entity.is_variable && protocol.n_protocol_conditions) {
            setIsOpen(protocol);
          }
        },
      }}
    />
  );
};
